import { render } from "./DrawInput.vue?vue&type=template&id=70560087"
import script from "./DrawInput.vue?vue&type=script&lang=js"
export * from "./DrawInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__